<template>
  <div id="homeWrap">
    <el-container class="container">
      <el-header class="header">
        <HeaderCom @getIconType="getIconType" />
      </el-header>
      <el-container class="mainContentBox">
        <el-aside class="aside"
          :style="{width:isCollapse?'3%':'13%'}">
          <el-menu style="width: 100%"
            :default-active="$route.path"
            class="el-menu-vertical-demo"
            :unique-opened="true"
            :router="true"
            background-color="#0A1224"
            :collapse-transition='false'
            text-color="#9CA0AA"
            active-text-color="#16E9F4"
            :collapse="isCollapse">
            <sidebar-item v-for="item in routerList"
              :key="item.name"
              :index="' ' + item.name"
              :item="item" />
          </el-menu>
        </el-aside>
        <el-main class="main"
          :style="{width:isCollapse?'97%':'87%'}"
          id="mainPageID">
          <router-view :key="$route.fullPath"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import HeaderCom from "../components/HeaderCom";
import SidebarItem from "../components/SidebarItem";
export default {
  components: {
    HeaderCom,
    SidebarItem,
  },
  data() {
    return {
      routerList: [],
      isCollapse: false,
    };
  },
  watch: {
    $route: function (to, from) {
      document.getElementById("mainPageID").scrollTop = 0;
    },
  },
  methods: {
    getIconType(data) {
      this.isCollapse =
        window.sessionStorage.getItem("SidebarStatus") === "true"
          ? true
          : false;
    },
  },
  created() {},
  mounted() {
    this.routerList = JSON.parse(window.sessionStorage.getItem("routerList"));
  },
};
</script>

<style lang="scss" >
#homeWrap {
  .mainContentBox {
    .aside {
      .el-menu-item,
      .el-submenu__title {
        height: 50px;
        line-height: 50px;
        font-size: 16px;
      }
      /*隐藏文字*/
      .el-menu--collapse .el-submenu__title span {
        display: none;
      }
      /*隐藏 > */
      .el-menu--collapse .el-submenu__title .el-submenu__icon-arrow {
        display: none;
      }
    }
  }
}
</style>

<style scoped lang="scss">
#homeWrap {
  width: $width;
  height: $height;
  /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    border-radius: 10px;
    background-color: rgba(046, 72, 110, 0.1);
    background-color: transparent;
  }
  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 3px rgba(046, 72, 110, 0.1);
    border-radius: 10px;
    background-color: transparent;
  }
  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 3px rgba(046, 72, 110, 0.1);
    background-color: rgba(0, 0, 0, 0.3);
  }
  .container {
    width: 100%;
    height: 100%;
    .header {
      width: $width;
      height: 100px !important;
      background: #050b1f;
      padding: 0;
    }
    .aside {
      background: #0a1224;
      overflow: auto;
      // width: 13% !important;
      overflow-x: hidden;
    }
    .main {
      // width: 87% !important;
      height: 100%;
      margin: 0;
      padding: 0;
    }
    .mainContentBox {
      height: calc(100% - 100px) !important;
      -moz-user-select: none; /*火狐*/
      -webkit-user-select: none; /*webkit浏览器*/
      -ms-user-select: none; /*IE10*/
      -khtml-user-select: none; /*早期浏览器*/
      user-select: none;
    }
  }
}
</style>
